package songwritersnotebook.app.data

import kotlinx.serialization.Serializable
import kotlinx.serialization.SerialName

@Serializable
data class SessionInfo(
    val deviceId: String,
    val deviceName: String,
    val platform: String,
    val lastActive: Double = 0.0
)

@Serializable
data class UserProfile(
    @kotlinx.serialization.Transient
    var uid: String = "",
    @SerialName("subscriptionTier")
    var subscriptionTier: String = "FREE",
    @SerialName("dataStorageQuotaBytes")
    var dataStorageQuotaBytes: Double = 0.0,
    @SerialName("dataStorageUsedBytes")
    var dataStorageUsedBytes: Double = 0.0,
    @SerialName("email")
    var email: String = "",
    @SerialName("username")
    var username: String? = null,
    @SerialName("aiCreditsDaily")
    var aiCreditsDaily: Int = 0,
    @SerialName("aiCreditsOneTime")
    var aiCreditsOneTime: Int = 10,
    @SerialName("lastDailyCreditReset")
    var lastDailyCreditReset: Double = 0.0,
    @SerialName("activeSessions")
    var activeSessions: Map<String, SessionInfo> = emptyMap(),
    @SerialName("blockedUsers")
    var blockedUsers: Map<String, String> = emptyMap(),
    @SerialName("subscriptionPlatform")
    var subscriptionPlatform: String? = null,
    @SerialName("isAdmin")
    var isAdmin: Boolean = false,
    @SerialName("color")
    var color: Int? = null,
    @SerialName("hasSeededSampleSongs")
    var hasSeededSampleSongs: Boolean = false,
    @SerialName("hasSeenTutorial")
    var hasSeenTutorial: Boolean = false,
    @SerialName("hasPromptedForNotifications")
    var hasPromptedForNotifications: Boolean = false,
    @SerialName("deletionStatus")
    var deletionStatus: String? = null,
    @SerialName("accountDeletionRequestedAt")
    var accountDeletionRequestedAt: Double? = null,
    @SerialName("dailyAdCount")
    var dailyAdCount: Int = 0,
    @SerialName("lastAdDate")
    var lastAdDate: String = "",
    @SerialName("lastAdAwardedAt")
    var lastAdAwardedAt: Double = 0.0
) {
    /**
     * PRO UI: Returns the total credits available for display.
     * FREE/HOBBYIST users only see One-Time credits.
     * STUDIO users see both Daily and One-Time.
     */
    val totalAiCredits: Int
        get() = if (subscriptionTier == "STUDIO") {
            aiCreditsDaily + aiCreditsOneTime
        } else {
            aiCreditsOneTime
        }
}

@Serializable
data class PublicUser(
    val uid: String,
    val username: String
)
